// extracted by mini-css-extract-plugin
module.exports = {"content":"global-banner_content__zx1dA"};